import React from 'react';
import { Box } from '@mui/material';

interface DashboardGridProps {
  children: React.ReactNode;
}

/**
 * DashboardGrid Component
 * 
 * Provides consistent responsive grid layout for dashboard cards.
 * Used by both DashboardRenderer and DashboardSkeleton to ensure
 * consistent layout behavior across loading and loaded states.
 */
export const DashboardGrid: React.FC<DashboardGridProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 3,
      }}
    >
      {children}
    </Box>
  );
};

export default DashboardGrid;